import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/counts/customer.counts.query.gql"
import type {
  CustomerCountsQuery,
  CustomerCountsQueryVariables,
} from "@/v2-backoffice-client/customer/counts/__types__/customer.counts.query"

type Options = QueryHookOptions<
  CustomerCountsQuery,
  CustomerCountsQueryVariables
>

export function useCustomerCountsQuery(options?: Options) {
  return useQuery<CustomerCountsQuery, CustomerCountsQueryVariables>(
    query,
    options,
  )
}
